import React, { useState, useEffect } from "react";
import { useStateValue } from "./StateProvider";
import { Link } from "react-router-dom";

function Geolocator() {
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [{ location }, dispatch] = useStateValue();
  const [{ atCourse }, dispatch1] = useStateValue();

  useEffect(() => {
    findCoordinates();
  }, []);

  const polygonArray = [
    {
      latitude: 46.181707,
      longitude: -83.022107,
    }, //south of clubhouse
    {
      latitude: 46.193833,
      longitude: -83.032366,
    }, //NW
    {
      latitude: 46.189807,
      longitude: -83.011309,
    }, //NE
  ]; // perimetry of golf course

  const findCoordinates = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          let point = {
            lat: position.coords.latitude,
            long: position.coords.longitude,
          }; // example of point location

          // point = {
          //   lat: 46.182796,
          //   long: -83.022447
          // }; // frontdeck   needs to be blocked in production

          isAtCourse(point, polygonArray);
          //update State
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          //update State Provider
          dispatch({
            type: "SAVELOCATION",
            location: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
          });
        },
        (error) => alert(error.message),
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
      );
    }
  };

  const isAtCourse = (point, polygonArray) => {
    let x = point.lat;
    let y = point.long;

    let inside = false;
    for (
      let i = 0, j = polygonArray.length - 1;
      i < polygonArray.length;
      j = i++
    ) {
      let xLat = polygonArray[i].latitude;
      let yLat = polygonArray[i].longitude;
      let xLon = polygonArray[j].latitude;
      let yLon = polygonArray[j].longitude;
      let intersect =
        yLat > y !== yLon > y &&
        x < ((xLon - xLat) * (y - yLat)) / (yLon - yLat) + xLat;
      if (intersect) inside = !inside;
    }
    dispatch1({
      type: "ATCOURSE",
      atCourse: inside,
    });
    return inside;
  };

  return (
    <div>
      <h5 style={{ textAlign: "center" }}>
        {!atCourse
          ? " Not at Huron Pines or Location Permission Denied"
          : " Huron Pines"}
      </h5>
      <h6 style={{ textAlign: "center" }}>
        Lat: {latitude} Long:{longitude}
      </h6>

      <Link to="/range">
        <button className="btn__wagers">Range Distances</button>
      </Link>
    </div>
  );
}

export default Geolocator;
